
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Ust cubuktaki "Katki Paneli" butonunun gorsel tek kaynagi.
 *
 * `inert` modunda tanitim dialogundaki temsili menu cubugunda kullanilir:
 * tiklanamaz, odaklanamaz ve erisilebilirlik agacinda yer almaz. Boylece
 * tanitimdaki temsil, gercek butonla birebir ayni gorunur ve stil degisince
 * ikisi birlikte degisir (temsil "yalan" soylemez).
 */
@Component
export default class KatkiPaneliButton extends Vue {
  // type: Boolean sart — aksi halde `<katki-paneli-button inert />` prop'a "" gecer
  // ve Vue bunu true'ya cevirmez (inert mod sessizce kapali kalirdi).
  @Prop({ type: Boolean, default: false }) inert!: boolean;

  get labelClass(): string {
    // Gercek ust cubukta dar ekranlarda yalniz ikon gorunur; temsilde metin hep acik.
    return this.inert ? "" : "d-none d-md-inline";
  }
}
